<template>
  <!-- 重定向  -->
  <div class="second-page-wrapper">
    
  </div>
</template>
<style scoped>

</style>

<script>
export default {
  data() {
    return {

    };
  },
  mounted(){
      this.$router.replace({
        name: "BusinessIntro",
        query: {
          firstId: this.$route.query.firstId,
          workinfoId: this.$route.query.workinfoId,
          type: this.$route.query.type
        }
      });
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/businessWork/Children/redirect.vue